import React, { memo } from "react";

import { Spinner, Text } from "@performyard/py-components";

import { config } from "../config";

type SaveStatusProps = {
	isSaving: boolean;
	isSaved: boolean;
	hasError: boolean;
};

/**
 * Displays the save status indicator (Saving/Saved).
 * Shows nothing if there's an error or no status to display.
 * Memoized to prevent unnecessary re-renders.
 */
const SaveStatus = memo(({ isSaving, isSaved, hasError }: SaveStatusProps): React.ReactElement | null => {
	if (hasError) {
		return null;
	}

	if (isSaving) {
		return (
			<div className="flex items-center gap-2">
				<Text size="extra-small" weight="regular" color="neutral-7">
					Saving
				</Text>
				<Spinner size={config.iconSize.small} />
			</div>
		);
	}

	if (isSaved) {
		return (
			<Text size="extra-small" weight="regular" color="neutral-7">
				Saved
			</Text>
		);
	}

	return null;
});

SaveStatus.displayName = "SaveStatus";

export default SaveStatus;
